import { apiPath } from '../_utils/api-version'
import { ICategory, ICategoryWithProducts } from '../_types'
import { request } from './http-client'
import { TParams } from './types'

export function getCategoryList(
  params: TParams,
  shipper_id?: string,
  platform_id?: string,
  useDynamicLanguage = false
) {
  return request.get<{
    categories: ICategory[]
    count: string
  }>(apiPath('category', useDynamicLanguage), {
    params,
    headers: {
      Shipper: shipper_id,
      Platform: platform_id,
    },
  })
}

export function getCategoryById(
  id: string,
  shipper_id?: string,
  platform_id?: string,
  useDynamicLanguage = false
) {
  return request.get<ICategory>(
    `${apiPath('category', useDynamicLanguage)}/${id}`,
    {
      headers: {
        Shipper: shipper_id,
        Platform: platform_id,
      },
    }
  )
}

export function getCategoryWithProductsList(
  params: TParams,
  shipper_id?: string,
  platform_id?: string,
  useDynamicLanguage = false
) {
  return request.get<{
    categories: ICategoryWithProducts[]
    count: string
  }>(apiPath('category-with-products', useDynamicLanguage), {
    params,
    headers: {
      Shipper: shipper_id,
      Platform: platform_id,
    },
  })
}

export default getCategoryList
